import * as $ from "jquery";
import * as React from "react";
import "./../../js/select2.min.js";

interface Props extends React.InputHTMLAttributes<any> {
    onItemSelect?: Function;
    text?: string;
}

export default class SalesPersonSelect extends React.Component<Props, {}> {
    private baseUrl: string;
    private input: HTMLInputElement | null;

    constructor(props: Props) {
        super(props);

        this.baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
        this.input = null;
    }

    public render() {
        let { onItemSelect, text, ...rest } = this.props;
        return <input type="text" {...rest} ref={x => this.input = x} />;
    }

    public componentDidMount() {
        $(this.input!).select2({
            minimumInputLength: 1,
            ajax: {
                url: this.baseUrl + "api/users/search/sales",
                dataType: "json",
                quietMillis: 250,
                data: function (term: string, page: number) {
                    return {
                        query: term,
                    };
                },
                results: function (data: any, page: number) {
                    return {
                        results: data,
                    };
                },
                transport: function (params: any) {
                    params.beforeSend = function (request: any) {
                        request.setRequestHeader("Authorization", `Bearer ${localStorage.getItem("access_token")}`);
                    };
                    return $.ajax(params);
                },
            },
            formatResult: function (obj: any) {
                return obj.fullName;
            },
            formatSelection: function (obj: any) {
                return obj.fullName;
            },
            id: function (obj: any) {
                return obj.id;
            },
        });

        if (this.props.text !== undefined) {
            $(this.input!).select2("container").find(".select2-chosen").text(this.props.text);
        }
    }

    public componentWillUnmount() {
        $(this.input!).select2("destroy");
    }

    public get value() {
        return this.input!.value;
    }

    public set value(value: string) {
        $(this.input!).select2("val", value);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/SalesPersonSelect.tsx